
import * as d3 from 'd3'

export default {
  methods: {

    draw_Forms() {

      this.canvasForms = this.svg
      .append('g')
      .attr('id', `CANVAS_FROM`)
      .attr('transform', `translate(20, 20)`)
      .attr('cursor', 'default')
      .attr('font-family', 'roboto')

      this.canvasForms
      .append('image')
      .attr('transform', `translate(200, 30)`)
      .attr('xlink:href', this.HOST + `/SystemCompletion/Boundary/Rev0/sample.jpg`)
      .attr('x', 0).attr('y', 0).attr('opacity', .9)

      this.canvasForms
      .append('text')
      .attr('transform', `translate(0, 0)`).attr('font-size', 9).attr('fill', '#757575')
      .text('System No.')

      this.canvasForms
      .append('text')
      .attr('transform', `translate(0, 15)`).attr('font-size', 14).attr('fill', '#333')
      .text(this.rawData.SYS)

      this.canvasForms
      .append('text')
      .attr('transform', `translate(150, 0)`).attr('font-size', 10).attr('fill', '#757575')
      .text('PCC Plan')

      this.canvasForms
      .append('text')
      .attr('transform', `translate(150, 15)`).attr('font-size', 13).attr('fill', '#757575')
      .text(this.rawData.PCC_P)

      this.canvasForms
      .append('text')
      .attr('transform', `translate(250, 0)`).attr('font-size', 10).attr('fill', '#757575')
      .text('PCC Actual')

      this.canvasForms
      .append('text')
      .attr('transform', `translate(250, 15)`).attr('font-size', 13).attr('fill', '#757575')
      .text(this.rawData.PCC_A)

      this.canvasForms
      .append('text')
      .attr('transform', `translate(0, 40)`).attr('font-size', 9).attr('fill', '#757575')
      .text('System Description')

      this.canvasForms
      .append('text')
      .attr('transform', `translate(0, 55)`).attr('font-size', 13).attr('fill', '#757575')
      .text(this.rawData.SYS_DESC)


      

      this.draw_ITRs()


      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }

    },
  }
}